import React from "react";
import { useTranslation } from "react-i18next";

const LanguageSelector = () => {
  const { i18n } = useTranslation();

  const handleChange = (e) => {
    i18n.changeLanguage(e.target.value);
  };

  return (
    <div>
      <select
        id="languageSelect"
        className="form-select"
        value={i18n.language}
        onChange={handleChange}
        aria-label="Select language"
        style={{
          width: 70,
          backgroundColor: "transparent",
          border: "1px solid var(--natural-color)",
        }}
      >
        <option value="en">🇺🇸</option>
        <option value="tr">🇹🇷</option>
        <option value="ar">🇸🇦</option>
      </select>
    </div>
  );
};

export default LanguageSelector;
